import React, { useState, useEffect } from "react";
import "./App.css";

const DISPLAY_CARDS = 7;
const ROWS = [3, 4];

const cardNames = [
  "cups01", "cups02", "cups03", "cups04", "cups05", "cups06", "cups07", "cups08", "cups09", "cups10", "cups11", "cups12", "cups13", "cups14",
  "maj01", "maj02", "maj03", "maj04", "maj05", "maj06", "maj07", "maj08", "maj09", "maj10", "maj11", "maj12", "maj13", "maj14", "maj15", "maj16", "maj17", "maj18", "maj19", "maj20", "maj21", "maj22",
  "pents01", "pents02", "pents03", "pents04", "pents05", "pents06", "pents07", "pents08", "pents09", "pents10", "pents11", "pents12", "pents13", "pents14",
  "swords01", "swords02", "swords03", "swords04", "swords05", "swords06", "swords07", "swords08", "swords09", "swords10", "swords11", "swords12", "swords13", "swords14",
  "wands01", "wands02", "wands03", "wands04", "wands05", "wands06", "wands07", "wands08", "wands09", "wands10", "wands11", "wands12", "wands13", "wands14"
];

const messages = [
  "Ты готов узнать правду, которая изменит твою жизнь?",
  "Судьба уже давно приготовила тебе знак...",
  "Тени прошлого открывают перед тобой дверь...",
  "Будущее шепчет тебе на ухо. Ты слышишь?",
  "Карты не врут... Но готов ли ты узнать истину?"
];

const App = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [shuffledCards, setShuffledCards] = useState([]);
  const [flippedCards, setFlippedCards] = useState({});
  const [finalMessage, setFinalMessage] = useState("");

  useEffect(() => {
    const randomCards = [...cardNames].sort(() => 0.5 - Math.random()).slice(0, DISPLAY_CARDS);
    setShuffledCards(randomCards);

    const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    const background = isMobile ? "/bg-mobile.jpg" : "/bg-desktop.jpg";

    document.body.style.backgroundImage = `url(${background})`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundRepeat = "no-repeat";

    // Telegram WebApp Init
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    }
  }, []);

  useEffect(() => {
    if (selectedCards.length === 3) {
      setFinalMessage(messages[Math.floor(Math.random() * messages.length)]);

      setTimeout(() => {
        const container = document.querySelector(".cards-container");
        if (container) container.classList.add("cards-hidden");
      }, 500);
    }
  }, [selectedCards]);

  const handleCardClick = (index) => {
    if (selectedCards.length < 3 && !selectedCards.includes(index)) {
      setSelectedCards([...selectedCards, index]);
      setFlippedCards({ ...flippedCards, [index]: true });
    }
  };

  // ✅ НОВЫЙ ОБРАБОТЧИК — обычная кнопка
  const handleSendCards = () => {
    const selected = selectedCards.map((index) => shuffledCards[index]);
    
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      const dataString = JSON.stringify({ cards: selected });
      
      console.log('Отправляем данные:', dataString);
      tg.sendData(dataString);
    }
  };

  return (
    <div className="container">
      <h1>{finalMessage || "Выберите 3 карты Таро"}</h1>
      <div className={`cards-container ${selectedCards.length === 3 ? "cards-hidden" : ""}`}>
        {selectedCards.length === 3 ? (
          <div className="selected-cards">
            {selectedCards.map((index) => (
              <div key={index} className="card selected">
                <img src={`/cards/${shuffledCards[index]}.jpg`} alt={shuffledCards[index]} />
              </div>
            ))}
            {/* ✅ ОБЫЧНАЯ HTML КНОПКА */}
            <button className="send-button" onClick={handleSendCards}>
              Получить расклад 🔮
            </button>
          </div>
        ) : (
          [0, 3].map((startIdx, rowIndex) => (
            <div key={rowIndex} className="row">
              {shuffledCards.slice(startIdx, startIdx + ROWS[rowIndex]).map((card, idx) => {
                const globalIndex = startIdx + idx;
                return (
                  <div
                    key={globalIndex}
                    className={`card ${flippedCards[globalIndex] ? "flipped" : ""}`}
                    onClick={() => handleCardClick(globalIndex)}
                  >
                    <img
                      src={flippedCards[globalIndex] ? `/cards/${shuffledCards[globalIndex]}.jpg` : "/cards/back.jpg"}
                      alt={flippedCards[globalIndex] ? shuffledCards[globalIndex] : "Таро карта"}
                    />
                  </div>
                );
              })}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default App;